import { Component, OnInit } from '@angular/core';
import { securityActions } from '@src/store/reducers/securityReducer';
import { Store } from '@src/store';
// import { DialogManagerService } from '@src/services';
// import { userActions } from '@src/store/reducers/userReducer';

// import $ from 'jquery';

@Component({
    selector: 'oidc-conf',
    template: require('./oidc.component.html'),
    styles: [require('./oidc.component.scss')]
})
export class OidcComponent implements OnInit {
    public hasItems = false;
    public selectedDomain: any;
    public GroupsMapping:any;
    // private unSubscribe: any;

    constructor(private store:Store){}
    public configProprties:any;
    public async ngOnInit() {
        const action = { type: securityActions.GET_OIDC_COfIGURATIONS};
        const response = await this.store.dispatch(action);
        this.configProprties = response.data
        this.GroupsMapping = this.configProprties.GroupsMapping
    }
  public updateConfig(object){
    this.configProprties[object?.fieldName] = object.data;
  }

  public updateMapping(object){
    if(this.configProprties['GroupsMapping'].length > 0){
      let index  = this.configProprties['GroupsMapping'].findIndex(x => x.objectId == object.objectId && x.objectType == object.objectType)
      if(index == -1){
        this.configProprties['GroupsMapping'].push(object)
      }
      else {
        if(object.groupName == ''){
          this.configProprties['GroupsMapping'].splice(index, 1)
        }
        else{
          this.configProprties['GroupsMapping'][index] = object;
        }
      }
    }
    else{
      this.configProprties['GroupsMapping'].push(object)
    }
  }

  public async saveConfig(configFlag:boolean){
    let payload = {flag:configFlag,configData:this.configProprties}
    const action = { type: securityActions.SET_OIDC_COfIGURATIONS ,payload:payload};
    await this.store.dispatch(action);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/usersRolesManagement/advancedManagement/oidc-configuration/oidc.component.ts